import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const DANGEROUS_EVENT_DANGEROUS_ELEMENT_LINKS_ENDPOINT = 'catalog-dangerous-event-dangerous-element-links';
export const DANGEROUS_EVENT_DANGEROUS_ELEMENT_LINKS_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(DANGEROUS_EVENT_DANGEROUS_ELEMENT_LINKS_ENDPOINT);
export const DANGEROUS_ELEMENT_CONTROL_MEASURE_LINKS_ENDPOINT = 'catalog-dangerous-element-control-measure-links';
export const DANGEROUS_ELEMENT_CONTROL_MEASURE_LINKS_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(DANGEROUS_ELEMENT_CONTROL_MEASURE_LINKS_ENDPOINT);
export const CONTROL_MEASURE_OPERATIONAL_MONITORING_LINKS_ENDPOINT = 'catalog-control-measure-operational-monitoring-links';
export const CONTROL_MEASURE_OPERATIONAL_MONITORING_LINKS_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(DANGEROUS_ELEMENT_CONTROL_MEASURE_LINKS_ENDPOINT);
export const CONTROL_MEASURE_EQUIPMENT_LINKS_ENDPOINT = 'catalog-control-measure-equipment-links';
export const CONTROL_MEASURE_EQUIPMENT_LINKS_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CONTROL_MEASURE_EQUIPMENT_LINKS_ENDPOINT);
export const REGISTRIES_ENDPOINT = 'registries';
export const REGISTRIES_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(REGISTRIES_ENDPOINT);

export const dangerousEventDangerousElementLinksStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const dangerousElementControlMeasureLinksStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const controlMeasureOperationalMonitoringLinksStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const controlMeasureEquipmentLinksStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const registriesStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export enum REGISTRY_TYPE_ENUM {
  DANGEROUS_EVENT = 'dangerous-event',
  DANGEROUS_ELEMENT = 'dangerous-element',
  CONTROL_MEASURE = 'control-measure',
  OPERATIONAL_MONITORING = 'operational-monitoring',
  EQUIPMENT = 'equipment'
}